import React from "react";
import './_featuredSolutionCard.scss';

export default class extends React.Component {
    render() {
        const { data } = this.props;
        const id = this.parseIdFromUrl(data.url);
        const url = `/ecosystem/featured/${id}/`;

        const headerStyle = {
            backgroundImage: `url("${data.meta.banner_image}")`,
            filter: `hue-rotate(${data.meta.banner_hue}deg)`
        }
        const className = ("pubhub-ecosystem-featuredsolution-card " + (this.props.className || '')).trim();
        return (
            <div id={this.props.id} className={className}>
                <a className='fsc-item' href={url}>
                    <div className='header'>
                        <div className='bg' style={headerStyle} />
                        <div className='action'>{data.meta.vertical}</div>
                        <div className='title' title={data.name}>{data.name}</div>
                    </div>
                    <div className='body'>
                        <div className='desc' title={data.description}>{data.description}</div>
                        <div className='logo'>
                            <img src={data.meta.partner_logo} />
                        </div>
                    </div>
                </a>
            </div>
        );
    }

    parseIdFromUrl(url) {
        if(!url) return '';

        const index = url.lastIndexOf('/') + 1;
        return url.substring(index);
    }
}